/**
 *
 * FlashCardDetail
 *
 */

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ToggleFilterBtn',

  computed: {
    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isNoCard: 'isNoCard',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    toggleFilter() {
      this.mm_SET_MODAL_CARD_TYPE('filter');
    },
  },
};
